import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DeviceDetectorService } from 'ngx-device-detector';
import { environment } from 'src/environments/environment';
import { Observable, Subject, Subscriber, Subscription, throwError } from 'rxjs';
import { CommonService } from './common.service';
import { LoadingService } from '../sharedModule/loadingModule/loading.service';
import { AlertService } from './alert.service';
import { tap } from 'rxjs-compat/operators/tap';
import { catchError, map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { v4 as uuidv4 } from 'uuid';
import { OUPCookiesService } from './oupCookies.service';

@Injectable({ providedIn: 'root' })
export class DataService {
	private _jwt: string = null;
	public jwt$:Subject<string> = new Subject();
	public jwtObj: any = null;

    public user_role:any 
	// public appId : string = 'starwishgame';
	public appId : string = 'rainbowone';

	private _userInfo:any = null;
	public schoolInfo:any = {};
	public userInfo$:Subject<any> = new Subject();
	public get userInfo():any {
		return this._userInfo;
	}
	public set userInfo(value:any) {
		// console.trace('set userInfo', value);
		if (this._userInfo == value) return;
		let oup = this?._userInfo?.oup;
		this._userInfo = value;
		if (this._userInfo && oup && !this._userInfo.oup) {
			this._userInfo.oup = oup;
		}
		this.userInfo$.next(value);
		if (value && value.personalSettings && value.personalSettings.lang) this.setLang(value.personalSettings.lang);
		if (value && value.personalSettings && value.personalSettings.ttsLangType) this.setTTSLangType(value.personalSettings.ttsLangType);

		if (this._userInfo) this._userInfo.planType = () => {
			let planType: string = (this.userInfo.school && this.userInfo.school.plan_type && this.userInfo.school.plan_type.trim().toLowerCase()) || '';
			let extraTrial: string = (this.userInfo.school && this.userInfo.school.extra_trial && this.userInfo.school.extra_trial.trim().toLowerCase()) || '';
			if (planType == 'pro' || extraTrial == 'extra pro') return 'pro';
			if (planType == 'basic' || extraTrial == 'extra basic') return 'basic';
			if (planType == 'free') return 'free';
			return 'none';
		}
	}

	public lang:string = "tc";// = this.getLang();
	public ttsLangType: string = "zh-HK";
	public dev;

	public orgs: any[] = [];

	public apiUrl: string;
	// public devApiUrl: string;
	public isProd:boolean = false;
	public isInWeb:boolean = true;
	public set jwt(value: string){
		this._jwt = value;
		var newJWTObject = this.jwt ? this.decodeJWT(this.jwt) : null;
		/*
		if(newJWTObject && this.jwtObj)
		{
			console.log(
				"old jwt", this.jwtObj.time , "\r\n",
				"new jwt", newJWTObject.time, "\r\n"
			);
		}
		*/
		this.jwtObj = newJWTObject;
		this.jwt$.next(value);
	}

	public get jwt():string
	{
		return this._jwt;
	}

	decodeJWT(jwt:string)
	{
		if(jwt)
		{
			let jwts: string[] = jwt.split('.');
			return JSON.parse(atob(jwts[1]));
		} else {
			return null;
		}
	}
	public isCalling(): boolean {
		return (window['httpCalling'] && window['httpCalling'].length > 0);
	}
	public calling(): Function {
		//console.log("calling()");
		// console.log(new Error().stack);
		if (!window['httpCalling']) window['httpCalling'] = [];
		let _calling = window['httpCalling'];
		let random: number = +new Date() * 1000 + Math.floor(Math.random() * 1000);
		_calling.push(random);
		let clsFn: Function = (id: number): void => {
			//console.log("calling.response()");
			for (let i = 0; i < _calling.length; i++) {
				if (_calling[i] == random) _calling.splice(i, 1);
			}
			//console.log("calling.length = ", _calling.length);
		}
		setTimeout(() => {
			//console.log("calling.timeout");
			clsFn()
		}, 30000);
		return clsFn;
	}
	private preloadedModules = new Map<string, Promise<any>>();
	constructor(
		private coms: CommonService,
		public device: DeviceDetectorService,
		private http: HttpClient,
		private lds: LoadingService,
		private als: AlertService,
		private router: Router,
		public translate:TranslateService,
		private oupCookies: OUPCookiesService
	) {
		this.userInfo$.subscribe(()=>{
			if (sessionStorage.getItem('test')){
				return;
			}
			this.coms.waitFor(()=>this.getPersonalSetting('lang'), 100, 100).then((langCode:string)=>{
				this.setLang(langCode);
				this.oupCookies.changeLang(langCode);
			}).catch(()=>{});
			this.coms.waitFor(()=>this.getPersonalSetting('ttsLangType'), 100, 100).then((langCode:string)=>{
				this.setTTSLangType(langCode);
			}).catch(()=>{});
		});
		/*let proUrl: string = "//api.openknowledge.hk/RainbowOne/index.php/PHPGateway/proxy/2.8/";
		let testUrl: string = "//ro2.azurewebsites.net/RainbowOne/index.php/PHPGateway2/proxy/2.8/";
		if (location.hostname == 'dev.openknowledge.hk' || location.port) {
			testUrl = '//dev.openknowledge.hk/RainbowOne/index.php/PHPGateway2/proxy/2.8/';
			// testUrl = '//localhost:8000/index.php/PHPGateway2/proxy/2.8/';
			proUrl = testUrl;
		} else {
			// proUrl = '//' + location.hostname + '/RainbowOne/index.php/PHPGateway2/proxy/2.8/';
			// testUrl = proUrl;
		}*/
		const part2Url = (()=>{
			try { //試用new URL()的方法取得path，咁不用hard-code path"/RainbowOne" or "/OUP/"
				let apiUrl:string = environment.apiUrl;
				if (apiUrl.startsWith('//')) apiUrl = 'https:' + apiUrl;
				return new URL(apiUrl).pathname;
			} catch (e) { //如果不成功才用回原本的方法
				// "/RainbowOne"後不加"/"因為會用"/RainbowOnePre"
				const serverAppFolderName:string = (environment.type=="oup-production") ? "/OUP/" : "/RainbowOne";
				return environment.apiUrl.substring(environment.apiUrl.indexOf(serverAppFolderName));
			}
		})();
		if (environment.production) {
			this.coms.log('In Production mode.');
			//this.apiUrl = proUrl;
			this.apiUrl = '//' + location.hostname + part2Url;
			// this.devApiUrl = this.apiUrl.replace(location.hostname, 'ro2.azurewebsites.net');
			this.isProd = true;
		} else if (environment.type == 'prod-proxy'){
			this.coms.log('In Proxy mode.');
			this.apiUrl = '//' + location.host + part2Url;
			this.isProd = true;
		} else {
			this.coms.log('In Development mode.');
			//this.apiUrl = testUrl;
			if(location.href.indexOf("//localhost")>=0) {
				const hostParts = location.hostname.split('.');
				if (hostParts.length > 1){ //localhost.xpyqdcs.com ,
					hostParts[0] = 'dev';
					this.apiUrl = '//' + hostParts.join('.') + part2Url;
				} else {
					this.apiUrl = environment.apiUrl;
				}
			} else if (location.href.indexOf('//10.') > -1 || location.href.indexOf('//192.') > -1 || location.href.indexOf('//127.') > -1){ // 開發用，local ＋ internal ip
				this.apiUrl = environment.apiUrl;
			} else {
				// 放上 dev server 要跟返 server 名，唔係就不能反應不同 domain 的不同反應。
				this.apiUrl = '//' + location.hostname + part2Url;
				// this.devApiUrl = this.apiUrl.replace(location.hostname, 'dev.openknowledge.hk');
			}
		}
//		this.apiUrl = 'https://dev.openknowledge.hk'  + part2Url;
		this.coms.log('Use URL: ' + this.apiUrl);

		if (document.cookie && (document.cookie.indexOf('login_session_token=') > 0)) {
			this.coms.log('Session: ' + document.cookie.indexOf('login_session_token='));
		} else {
			this.coms.log('No Session.');
		}

		//this.whoAmIApi();

		this.dev = {
			//E.g.:
			//device.getDeviceInfo().os = Windows/Mac/Android
			//device.getDeviceInfo().device = Android/iPad

			info: device.getDeviceInfo(),
			isMobile: device.isMobile() || device.isTablet(),
			isWindows: device.getDeviceInfo().os.toLowerCase() == 'windows',
			//isMac: device.getDeviceInfo().os.toLowerCase()=='mac' && device.getDeviceInfo().device.toLowerCase()!='ipad',
			isMac: device.getDeviceInfo().os.toLowerCase() == 'mac' && device.isDesktop(),
			isAndroid: device.getDeviceInfo().os.toLowerCase() == 'android',
			//isIpad: device.getDeviceInfo().device.toLowerCase()=='ipad'
			isIpad: device.getDeviceInfo().os.toLowerCase() == 'mac' && device.isTablet()
		};
		this.coms.log(this.dev);

		this.fixIosScroll();
	}
	//---------------------------------------------------------------------------------------------
	public whoAmIApi(): Promise<any> {
		return new Promise((resolve, reject) => {
			if (this.userInfo && this.userInfo.rainbow_one_school) {
				resolve(this.userInfo);
			} else {
				resolve(
					this.post2({
						data: {
							api: 'ROMediaLibrary.whoAmI',
							json: []
						}
					}).then((res: any) => {
						if (res && res.data) this.userInfo = res.data;
						if (this.userInfo) {
							this.userInfo.planType = () => {
								let planType: string = (res.data.rainbow_one_school && res.data.rainbow_one_school.plan_type && res.data.rainbow_one_school.plan_type.trim().toLowerCase()) || '';
								let extraTrial: string = (res.data.rainbow_one_school && res.data.rainbow_one_school.extra_trial && res.data.rainbow_one_school.extra_trial.trim().toLowerCase()) || '';
								if (planType == 'pro' || extraTrial == 'extra pro') return 'pro';
								if (planType == 'basic' || extraTrial == 'extra basic') return 'basic';
								if (planType == 'free') return 'free';
								return 'none';
							}
						}
						return this.userInfo;
					})
				)
			}
		});
	}

	public getPersonalSetting(key:string, useDefault:boolean = false):any {
		if(!useDefault && this.userInfo && this.userInfo.personalSettings && this.userInfo.personalSettings.hasOwnProperty(key))
			return this.userInfo.personalSettings[key];
		
		// use default settings
		var def:any ={
			evaluation_comment:1, // 上課批改學生可否比like
			evaluation_sync:1, // 上課批改學生同步
			mainMenuIconDisplayMode:"grid",
			workspace_fav_subjects:[],

			onoff_split_view:false, // 分頁
			onoff_student_list:true, // 學生批改列表
			onoff_correction_list:true, // 學生批改列表
			onoff_correction_frame:true, // 改正框
			onoff_marking_layer:true, // 顯示批改
			onoff_teacher_sticker_list:true, // 顯示學校設定了可用的 sticker
			panAction:parseInt(this.userInfo && this.userInfo.school_id)==1675 ? "student" : "page", // 天虹批改左滑動設定，預設是轉學生
			paperSrc:"image", // exam paper component 顯示的資料來源
			correctionToolsLayout:"bottom", // 批改時的 UI layout

			schoolStickerPanel:{ver:1,x:10,y:50,xAlign:"right",yAlign:"top",width:240,height:200,perRow:3,dockHeight:178},
			studentListPanel:{ver:1,x:10,y:50,xAlign:"left",yAlign:"top"},
			correctionEpenSwitchSetting:{ver:1,x:0,y:152,xAlign:"left",yAlign:"bottom"},
			pendingCorrectionPanel:{ver:1,x:0,y:50,xAlign:"right",yAlign:"top"},
			ttsLangType: "zh-HK"
		};
		return def[key];
	}

	public setPersonalSetting(key:string, value:any):Promise<void> {
		const that:any = this;
		return new Promise((resolve, reject)=>{;
			if (!this.userInfo) {
				console.log('no userInfo!');
				setTimeout(()=>resolve(this.setPersonalSetting(key, value)), 500);
			} else {
				if (!that.userInfo.personalSettings) that.userInfo.personalSettings = {};
				that.userInfo.personalSettings[key] = value;

				//因在login前會先用localStorage，在saveDB前都需更新localStorage
				try {
					let dataString:string = localStorage.getItem('homeScreen_data');
					let dataJson = JSON.parse(dataString);
					dataJson.account.personalSettings = that.userInfo.personalSettings;
					dataString = JSON.stringify(dataJson);
					localStorage.setItem('homeScreen_data', dataString);
				} catch(e) {}

				that.post2({data:{
					api:'Account.savePersonalSetting', loading: false,
					json:[that.userInfo.personalSettings],
					lang: this.lang
				}}).then((res:any)=>{
					resolve();
				});
			};
		});
	}
	//---------------------------------------------------------------------------------------------
	public get(url: string, option: any = {}): Observable<any> {
		console.log("get:", url);
		let callEnd: Function = this.calling();
		return this.http.get(url, option).pipe(tap(() => callEnd()),
			tap((res: any) => {
				if (typeof res === 'object') {
					if (res.code == 12 && res.msg == 'LOGIN_REQUIRED') {
						this.router.navigate(['login']);
					}
				}
			}),
			catchError((err) => {
				callEnd();
				return throwError(err);
			}));
	}
	//---------------------------------------------------------------------------------------------
	public getWithJwt(url: string, option: any = {}): Observable<any> {
		if (!option.headers) option.headers = new HttpHeaders();
		if (!this.jwt && localStorage.getItem('common_jwt')){
			this.jwt = localStorage.getItem('common_jwt');
		}
		if (this.jwt) option.headers = option.headers.append("Authorization", 'Bearer ' + this.jwt);
		// if (this.appId && window.location.href.indexOf('localhost') == -1 && window.location.href.indexOf('//192.168') == -1) option.headers.append("app-id", this.appId);
		option.headers.append("app-id", this.appId);
		option.headers.append("accept-language", this.lang);
		return this.get(url, option);
	}
	//-------------------------------------------------------------------------------------------------
	public get2(config: any): Promise<any> {
		return new Promise((resolve: Function, reject: Function) => {

			let callEnd: Function = this.calling();
			let apiConfig: any = {
				url: this.apiUrl,
				data: {},
				option: { headers: new HttpHeaders() },
				loading: config && config.loading !== undefined?config.loading:true,
				jwt: true,
				retryDialog: true
			}
			for (let key in apiConfig) if (config.hasOwnProperty(key)) apiConfig[key] = config[key];
			//Set Token
			if (apiConfig.jwt && this.jwt) apiConfig.option.headers = apiConfig.option.headers.append("Authorization", 'Bearer ' + this.jwt);
			apiConfig.option.headers = apiConfig.option.headers.append("app-id", this.appId);
			apiConfig.option.headers = apiConfig.option.headers.append("accept-language", this.lang);
			let urlWithPara: string = apiConfig.url;
			for (let key in apiConfig.data) {
				urlWithPara += (urlWithPara.indexOf("?") > -1 ? "&" : "?") + key + "=" + encodeURIComponent(apiConfig.data[key]);
			}

			let apiCall: Function = () => {
				const label = apiConfig?.data?.api;
				let cls: Function = apiConfig.loading ? this.lds.add(label) : null
				let subscription: Subscription;
				let trial: number = 0;
				let retryFn: Function = () => {
					subscription = this.http.get(urlWithPara, apiConfig.option).subscribe((res: any) => {
                        callEnd();
                        if (typeof res == 'object' && Array.isArray(res) == false && res != null) {
                            if (res.code == 12 && res.msg == 'LOGIN_REQUIRED') {
                                this.router.navigate(['login']);
                            }
                        }
                        resolve(res);
                        if (cls) cls();
                    }, (err: Error) => {
                        callEnd();
                        this.coms.log('Error on apiCall [' + apiConfig.data.api + ']: ' + JSON.stringify(err));
                        if (trial < 4) {
                            trial++;
                            if (subscription) subscription.unsubscribe();
                            subscription = null;
                            let waitMs:number = [1000, 3000, 7000, 15000][trial-1];
							this.coms.log('Retry apiCall [' + apiConfig.data.api + '] after ' + (waitMs / 1000) + 'sec.');
							setTimeout(() => retryFn(), waitMs);
                        } else {
                            if (cls) cls();
                            if (subscription) subscription.unsubscribe();
                            subscription = null;
                            if (apiConfig.retryDialog) {
                                this.als.alert2('commonService.processTimeoutMsg', null, { btns:[ [{key:'retry',labelKey:"commonService.processTimeoutRetry", ngStyle:{backgroundColor:'#8ABF52'}}, 'cancel'] ] }).then((key:string)=>{
                                    if (key=='retry') {
                                        this.coms.log('Retry apiCall [' + apiConfig.data.api + ']');
                                        apiCall();
                                    } else {
                                        this.coms.log('Cancel apiCall [' + apiConfig.data.api + ']');
                                        reject('cancel');
                                    }
                                });
                            } else {
                                reject('Fail to call api [' + apiConfig.data.api + ']')
                            }
                        }
                    });
				}
				retryFn();
			}
			apiCall();

		});
	}
	//---------------------------------------------------------------------------------------------
	public post(
		api: string, json: any[] = [{}], 
		url: string = this.apiUrl, 
		data: any = {}, option: any = {},timeout:any =null): Observable<Object> {
		console.log("post", api);
		let callEnd: Function = this.calling();
		//let url = environment.apiUrl;
		if (!data.api) data.api = api;
		if (!data.json) data.json = JSON.stringify(json);

		if (!option.headers) option.headers = new HttpHeaders();
		if(option.idempotencyKey)
		{
			if(option.idempotencyKey === true)
				option.headers = option.headers.append("Idempotency-Key", this.generateIdempotencyKey());
			else if(typeof option.idempotencyKey == "string")
				option.headers = option.headers.append("Idempotency-Key", option.idempotencyKey);
		}
		
		//Set Token
		if (!this.jwt && localStorage.getItem('common_jwt')){
			this.jwt = localStorage.getItem('common_jwt');
		}
		if (this.jwt) option.headers = option.headers.append("Authorization", 'Bearer ' + this.jwt);
		if (timeout) {
			option.headers.append("timeout" ,`${timeout}`)
		}
		data.lang = this.lang;
		data.appId = this.appId2;
		
		// if (this.appId && window.location.href.indexOf('localhost') == -1 && window.location.href.indexOf('//192.168') == -1) option.headers = option.headers.append("app-id", this.appId);
		option.headers = option.headers.append("app-id", this.appId ? this.appId : 'unset');
		option.headers = option.headers.append("accept-language", this.lang ? this.lang : 'unset');
		url = url +'?' + api;
		return this.http.post(url, data, option).pipe(tap(() => callEnd()), tap((res: any) => {
			if (typeof res === 'object' && Array.isArray(res) == false && res != null) {
				if (res.code == 12 && res.msg == 'LOGIN_REQUIRED') {
					this.router.navigate(['login']);
				}
				if (res.code == 11 && res.msg){
					let msg = null;
					if (res.msg == 'No authorization items purchased'){
						msg = {tc:'未能登入，你的戶口尚未購買授權項目。請聯絡系統管理員以獲取協助。',sc:'未能登入，你的户口尚未购买授权项目。请联络系统管理员以获取协助。',en:'Unable to log in. No authorization items purchased. Contact the administrator for assistance.'}[this.lang];
					} else if (res.msg == 'authorization items have expired'){
						msg = {tc:'未能登入，你的購買的授權項目已過期。請聯絡系統管理員以獲取協助。',sc:'未能登入，你的购买的授权项目已过期。请联络系统管理员以获取协助。',en:'Unable to log in. Your authorization items have expired. Contact the administrator for assistance.'}[this.lang];
					} else if (res.msg == 'authorization items is diabled'){
						msg = {tc:'未能登入，你的購買的授權項目已停用。請聯絡系統管理員以獲取協助。',sc:'未能登入，你的购买的授权项目已停用。请联络系统管理员以获取协助。',en:'Unable to log in. Your authorization items is disabled. Contact the administrator for assistance.'}[this.lang];
					}
					if (msg){
						this.als.alert2(msg, null, { btns: [['ok']] });
						this.router.navigate(['login']);
						return;
					}
				}
			}
		}),
			catchError((err) => {
				callEnd();
				this.lds.removeAll();
				return throwError(err);
			}));
	}
	//-------------------------------------------------------------------------------------------------
	public call(api: string, ...parameters: any[]): Promise<any> {
		this.coms.info(api);
		var p = this.post2(
			{
				data: {
					api: api,
					json: parameters,
					lang: this.lang
				}
			}
		);
		p.then(() => {
			this.coms.info(api + ":success");
		}, () => {
			this.coms.error(api + ":failed");
		})
		return p;
	}

	private generateIdempotencyKey()
	{
		return uuidv4();
	}

	public shouldRetry(statusCode:number):boolean
	{
		// should not retry list
		if(statusCode >= 200 && statusCode< 400 )
		{
			return false;
		} else if([500].indexOf(statusCode) !== -1)
		{
			return true;
		} else if([408, 400, 401, 403, 404, 409].indexOf(statusCode) !== -1)
		{
			return false;
		} else if([429, 502, 503, 504].indexOf(statusCode) !== -1) {
			return true;
		}
		return false;
	}
	
	public stream(payload: Record<string, unknown>): Observable < any > {
		return new Observable<any>((subscriber: Subscriber<any>) => {
			const abortCtrl = new AbortController();
			const signal = abortCtrl.signal;
			let isCompleted = false;

			payload.stream = true;

			const runStream = async () => {
				try {
					const headers: Record<string, string> = {
						"Content-Type": "application/json",
					};
					if (this.jwt) {
						headers.Authorization = `Bearer ${this.jwt}`;
					}

					const response = await fetch(this.apiUrl, {
						method: "POST",
						headers,
						body: JSON.stringify(payload),
						signal,
					});

					if (!response.ok || !response.body) {
						throw new Error(`HTTP ${response.status}`);
					}

					const reader = response.body.getReader();
					const decoder = new TextDecoder("utf-8");
					let buffer = "";

					// ========= SSE PARSER STATE（參考所有主流庫的標準狀態變數）=========
					let currentEventName = "message"; // SSE spec default
					let currentData = "";
					let currentId = "";
					let currentRetry: number | undefined;

					/**
					 * Dispatch complete SSE event block (empty line triggers this)
					 * 【標準實踐：獨立函數，所有開源parser通用模式】
					 */
					const dispatchEvent = () => {
						if (isCompleted) return;
						// 備存當前ID，SSE規範：id 會持續生效直到下一個id覆蓋
						const eventIdSnapshot = currentId;
						const eventNameSnapshot = currentEventName;
						const rawPayload = currentData;

						// Reset state for next block (SPEC)
						currentEventName = "message";
						currentData = "";

						// OpenAI compatible terminator
						if (rawPayload === "[DONE]") {
							isCompleted = true;
							subscriber.complete();
							return;
						}

						try {
							const chunk = JSON.parse(rawPayload);

							// Business finish packet
							if (chunk.done === true) {
								isCompleted = true;
								if (chunk.error) {
									subscriber.next({
										type: "error",
										message: chunk.error.message,
									});
								} else {
									subscriber.next({
										type: "finish",
										template: chunk.data.template,
										element: chunk.data.element,
										eventName: eventNameSnapshot,
										lastEventId: eventIdSnapshot,
									});
								}
								subscriber.complete();
								return;
							}

							// Normal data chunk
							subscriber.next({
								type: "data",
								eventName: eventNameSnapshot,
								lastEventId: eventIdSnapshot,
								data: chunk,
							});
						} catch {
							// Invalid JSON, forward raw SSE payload
							subscriber.next({
								type: "raw",
								eventName: eventNameSnapshot,
								lastEventId: eventIdSnapshot,
								rawData: rawPayload,
							});
						}
					}

					while (true) {
						const { done, value } = await reader.read();
						if (done) break;

						buffer += decoder.decode(value, { stream: true });
						const lines = buffer.split("\n");
						buffer = lines.pop() || "";

						for (const line of lines) {
							// Empty line = terminate event block → dispatch
							if (line.trim() === "") {
								dispatchEvent();
								continue;
							}

							// Comment line starts with ":" → skip (heartbeat)
							if (line.startsWith(":")) continue;

							const colonIndex = line.indexOf(":");
							if (colonIndex <= 0) continue;

							const field = line.slice(0, colonIndex);
							let value = line.slice(colonIndex + 1);
							// SSE Spec: remove one leading space after colon
							if (value.startsWith(" ")) value = value.slice(1);

							switch (field) {
								case "event":
									currentEventName = value;
									break;
								case "id":
									currentId = value;
									break;
								case "data":
									// Multi-line data: append newline between segments
									currentData += currentData ? "\n" : "";
									currentData += value;
									break;
								case "retry":
									const num = parseInt(value, 10);
									if (!Number.isNaN(num)) currentRetry = num;
									break;
							}
						}
					}

					// Stream close, flush unfinished block
					if (!isCompleted && (currentData || currentEventName !== "message")) {
						dispatchEvent();
					}

					if (!isCompleted) {
						isCompleted = true;
						subscriber.complete();
					}
				} catch (err) {
					const abortErr = err as Error;
					if (abortErr.name !== "AbortError" && !isCompleted) {
						isCompleted = true;
						subscriber.next({
							type: "error",
							message: abortErr.message ?? "stream unknown error",
						});
						subscriber.complete();
					}
				}
			};

			runStream();

			// Unsubscribe cleanup
			return () => {
				abortCtrl.abort();
			};
		});
	}
	public post2(config: {roNode?:boolean, retryDialog?:boolean, jwt?:boolean, url?:string, loading?:any, idempotencyKey?:string|true, data:any, option?:any, stringifyJson?:boolean}): Promise<any> {
		// Idempotency-Key: f47ac10b-58cc-4372-a567-0e02b2c3d479
		return new Promise((resolve: Function, reject: Function) => {
			//console.log("post2", config);
			let callEnd: Function = this.calling();
			let apiConfig: any = {
				url: config.url?config.url:this.apiUrl,
				data: {
					api: '',
					json: [{}],
					lang: this.lang
				},
				option: {
					headers: new HttpHeaders()
				},
				loading: config && config.loading !== undefined?config.loading:true,
				jwt: true,
				retryDialog: true,
				stringifyJson: true,
				roNode: false
			}
			for (let key in apiConfig) if (config.hasOwnProperty(key)) apiConfig[key] = config[key];
			if (!apiConfig.data.hasOwnProperty('json')) apiConfig.data.json = [{}];
			if (typeof apiConfig.data.json != 'string' && apiConfig.stringifyJson) apiConfig.data.json = JSON.stringify(apiConfig.data.json);
			//Set Token
			if (apiConfig.jwt && this.jwt) apiConfig.option.headers = apiConfig.option.headers.append("Authorization", 'Bearer ' + this.jwt);
			apiConfig.option.headers = apiConfig.option.headers.append("app-id", this.appId);
			apiConfig.option.headers = apiConfig.option.headers.append("accept-language", this.lang ? this.lang : 'unset');
			if(config.idempotencyKey)
			{
				if(config.idempotencyKey === true)
					apiConfig.option.headers = apiConfig.option.headers.append("Idempotency-Key", this.generateIdempotencyKey());
				else if(typeof config.idempotencyKey == "string")
					apiConfig.option.headers = apiConfig.option.headers.append("Idempotency-Key", config.idempotencyKey);
			}

			if (apiConfig.roNode) apiConfig.url = ((window.location.protocol == 'http:') ? environment.roNodeServer.httpHost : environment.roNodeServer.httpsHost) + '/api/' + apiConfig.url;
			let apiCall: Function = () => {
				const label = apiConfig?.data?.api;
				let cls: Function = apiConfig.loading ? this.lds.add(label) : null
				let subscription: Subscription;
				let trial: number = 0;
				let alertAndRetry = (msg:string)=>{
					if (cls) cls();
					if (subscription) subscription.unsubscribe();
					subscription = null;
					if (apiConfig.retryDialog) {
						let retryText = this.t('重試','重試','Retry');
						this.als.alert2(msg, null, { btns: [[{ key: 'retry', labelKey: retryText, ngStyle: { backgroundColor: '#8ABF52' } }, 'cancel']] }).then((key: string) => {
							if (key == 'retry') {
								this.coms.log('Retry apiCall [' + apiConfig.data.api + ']');
								apiCall();
							} else {
								this.coms.log('Cancel apiCall [' + apiConfig.data.api + ']');
								reject('cancel');
							}
						});
					} else {
						reject('Fail to call api [' + apiConfig.data.api + ']');
					}
				}
				let retryFn: Function = () => {
					subscription = this.http.post(apiConfig.url, apiConfig.data, apiConfig.option).subscribe((res: any) => {
						callEnd();
						if (typeof res == 'object' && Array.isArray(res) == false && res != null) {
							if (res.code == 12 && res.msg == 'LOGIN_REQUIRED') {
								this.router.navigate(['login']);
							}
						}
						resolve(res);
						if (cls) cls();
					}, (err: any) => {
						callEnd();
						this.coms.log('Error on apiCall [' + apiConfig.data.api + ']: ' + JSON.stringify(err));
						if(this.shouldRetry(err.status) == false)
						{
							if (cls) cls();
							if (subscription) subscription.unsubscribe();
							subscription = null;
							console.error(apiConfig.data.api, err.error);
							let processInprocessMsgText = this.t('無法完成動作，伺服器回應失敗。','无法完成动作，伺服器回应失败。','Unable to complete the action. Please try again later.');
							if(err.status === 409)
							{
								var response:any = err.error;
								if(response && response.status)
								{
									if(response.status == "failed")
									{
										// var header = new HttpHeaders()
										// header.delete("Idempotency-Key")
										// failed
										this.als.alert(processInprocessMsgText);
										reject(`${apiConfig.data.api} has already been processed and failed`);
									} else {

										reject(`${apiConfig.data.api} has already been processed`);
									}
								} else {
									this.als.alert(processInprocessMsgText);
									reject(`${apiConfig.data.api} has already been processed`);
								}
								
							} else {
								// reject('Fail to call api [' + apiConfig.data.api + ']');
								alertAndRetry(processInprocessMsgText);
							}
						} else {
							if (trial < 4) {
								trial++;
								if (subscription) subscription.unsubscribe();
								subscription = null;
								let waitMs: number = [1000, 3000, 7000, 15000][trial - 1];
								this.coms.log('Retry apiCall [' + apiConfig.data.api + '] after ' + (waitMs / 1000) + 'sec.');
								setTimeout(() => retryFn(), waitMs);
							} else {
								let processTimeoutMsgText = this.t('無法完成動作，伺服器沒有回應。','無法完成動作，伺服器沒有回應。','Cannot complete your action because server is not responding');
								alertAndRetry(processTimeoutMsgText);
							}
						}
					});
				}
				retryFn();
			}
			apiCall();
		});
	}
	//---------------------------------------------------------------------------------------------
	/**
	 * Calls the Starwish API with the specified HTTP method, endpoint, and data.
	 * 
	 * @param type The HTTP method to use ('get', 'post', 'put', 'delete').
	 * @param api The API endpoint to call (appended to the Starwish API base URL).
	 * @param data The data to send with the request (for POST/PUT).
	 * @returns A Promise that resolves with the API response or rejects with an error.
	 * 
	 * Example usage:
	 *   this.starwishApi('post', 'help-tool', { key: 'value' }).then(res => { ... });
	 * check https://dev.openknowledge.hk/Louis/public/docs.html for more details
	 */
	public starwishApi(type: string, api: string, data: any = {}): Promise<any> {
		return new Promise((resolve: Function, reject: Function) => {
			let starwishApiPrefix = 'https://' + location.hostname + '/OKAGames/public/index.php/api/';

			if (location.hostname.startsWith('app.starwishparty.com')) {
				starwishApiPrefix = 'https://pro.starwishparty.com/OKAGames/public/index.php/api/';
			}

			if (location.hostname.startsWith('localhost') || location.hostname.startsWith('192.') || location.hostname.startsWith('10.')) {
				starwishApiPrefix = 'https://dev.openknowledge.hk/OKAGames/public/index.php/api/';
			}

			if (location.hostname.startsWith('localhost') ){
				// starwishApiPrefix = 'http://localhost:8080/api/';
			}

			// if (environment.production) {
			// 	starwishApiPrefix = 'https://' + location.hostname + '/OKAGames/public/index.php/api/';
			// } else {
			// 	starwishApiPrefix = 'https://dev.openknowledge.hk/OKAGames/public/index.php/api/';
			// }

			const starwishApiUrl = starwishApiPrefix + api;
			const option: any = {
					headers: new HttpHeaders({ 'X-API-Key': '241281' })
			}
			if (this.jwt) option.headers = option.headers.append("Authorization", 'Bearer ' + this.jwt);
			let httpCall: any;
			switch (type.toLowerCase()) {
				case 'get':
					httpCall = this.http.get(starwishApiUrl, option);
					break;
				case 'put':
					httpCall = this.http.put(starwishApiUrl, data, option);
					break;
				case 'delete':
					httpCall = this.http.delete(starwishApiUrl, option);
					break;
				case 'post':
				default:
					httpCall = this.http.post(starwishApiUrl, data, option);
					break;
			}
			httpCall.subscribe((res: any) => {
				resolve(res);
			}, (err: any) => {
				// this.als.alert2(err.message, null, { btns:[ ['cancel'] ] }).then((key:string)=>{
				// 	reject(err);
				// });
			});
		});
	}
	//---------------------------------------------------------------------------------------------

	public postFormData(api: string, formData: FormData = new FormData(), url: string = this.apiUrl, option:any = {}): Observable<Object> {
		//let url = environment.apiUrl;
		if (!option.headers) option.headers = new HttpHeaders();
		if (!this.jwt && localStorage.getItem('common_jwt')){
			this.jwt = localStorage.getItem('common_jwt');
		}
		if (this.jwt) {
			option.headers = option.headers.append("Authorization", 'Bearer ' + this.jwt);
			formData.append('jwt', this.jwt);
		}
		formData.append('lang', this.lang);
		option.headers = option.headers.append("app-id", this.appId ? this.appId : 'unset');
		option.headers = option.headers.append("accept-language", this.lang ? this.lang : 'unset');
		formData.append("api", api);
		return this.http.post(url, formData);
	}

	//---------------------------------------------------------------------------------------------

	fixIosScroll() {
		if (this.dev.isMobile) {
			document.ontouchstart = function (e) {
				document.body.scrollTop = 0;
			};
			document.ontouchend = function (e) {
				document.body.scrollTop = 0;
			};
		}
	}
	//---------------------------------------------------------------------------------------------
	public isAppId(appId: string): boolean {
		return (this.appId && this.appId.toLowerCase() == appId.toLowerCase());
	}
	//---------------------------------------------------------------------------------------------
	public get appId2(){
		let appId = this.appId?this.appId:'';
		appId = appId.toLowerCase();
		appId = appId.replace(/\#.*/,'').replace(/%23.*/,'');
		appId = appId.replace(/\?.*/g,'');
		return appId;
	}
	//---------------------------------------------------------------------------------------------
	public async getResourceFile(src, outputType = 'file', file_type=''){
		if (src == null || src == ''){
			return Promise.reject('no file');
		}
		return this.post('Resource.get_blob', [src, file_type],this.apiUrl,{},{responseType: 'blob'}).pipe(map((res:any)=>{
			const arr = src.split('/');
			const filename = arr[arr.length - 1];
			if (outputType == 'blob'){
				return res;
			} else {
				return new File([res], filename);
			}
		})).toPromise();
	}
	//---------------------------------------------------------------------------------------------
	public setLang(langCode:string = null):Promise<void> {
		if(!langCode)
		{
			langCode = this.getLang();
				
		}
		this.lang = langCode;
		// localStorage.setItem('lang', langCode);
		this.translate.use(langCode);

		return this.setPersonalSetting('lang', langCode);
	}
	//---------------------------------------------------------------------------------------------
	public getLang(defaultLang:string = null):string {
		if (this.lang) return this.lang;
		this.lang = this.getPersonalSetting('lang');
		if(!this.lang) {
			this.lang = defaultLang ? defaultLang : 'tc';
			// this.setPersonalSetting('lang', this.lang);
		}
		return this.lang;
	}
	//---------------------------------------------------------------------------------------------
	public setLangBeforeLogin(langCode:string = null):void {
		if (!langCode) langCode = this.getLangBeforeLogin();
		localStorage.setItem('lang', langCode);
		this.translate.use(langCode);
	}
	//---------------------------------------------------------------------------------------------
	public getLangBeforeLogin(defaultLang:string = null):string {
		let lang:string = localStorage.getItem('lang');
		if (!lang) {
			lang = defaultLang ? defaultLang : 'tc';
			localStorage.setItem('lang', lang);
		}
		return lang;
	}
	//---------------------------------------------------------------------------------------------
	public getUserDisplayName():string {
		try {
			if (this.lang == 'en') {
				return this.userInfo.first_name + ' ' + this.userInfo.last_name;
			} else {
				return this.userInfo.displayName = this.userInfo.c_last_name + this.userInfo.c_first_name;
			}
		} catch (e) {
			return "";
		}
	}
	//---------------------------------------------------------------------------------------------
	public setTTSLangType(langCode:string = null):Promise<void> {
		if(!langCode) {
			langCode = this.getTTSLangType();
		}

		this.ttsLangType = langCode;
		return this.setPersonalSetting('ttsLangType', langCode);
	}

	public getTTSLangType(defaultLang:string = null):string {
		if (this.ttsLangType) return this.ttsLangType;
		this.ttsLangType = this.getPersonalSetting('ttsLangType');
		if(!this.ttsLangType) {
			this.ttsLangType = defaultLang ? defaultLang : 'zh-HK';
		}
		return this.ttsLangType;
	}
	//---------------------------------------------------------------------------------------------
	//---------------------------------------------------------------------------------------------
	preloadModule(modulePath: string): Promise<any> {
		if (this.preloadedModules.has(modulePath)) {
		return this.preloadedModules.get(modulePath)!;
		}

		const route = this.router.config.find(r => r.path === modulePath);
		if (route && route.loadChildren) {
		const loadPromise = (route.loadChildren as () => Promise<any>)()
			.then(module => {
			console.log(`模块预加载完成: ${modulePath}`);
			return module;
			})
			.catch(error => {
			console.error(`模块预加载失败: ${modulePath}`, error);
			this.preloadedModules.delete(modulePath);
			throw error;
			});

		this.preloadedModules.set(modulePath, loadPromise);
		return loadPromise;
		}

		return Promise.reject(`未找到模块路径: ${modulePath}`);
	}

	// 预加载多个模块
	preloadModules(modulePaths: string[]): Promise<any[]> {
		return Promise.all(modulePaths.map(path => this.preloadModule(path)));
	}

	// 检查模块是否已预加载
	isModulePreloaded(modulePath: string): boolean {
		return this.preloadedModules.has(modulePath);
	}

	isStudent(): boolean {
		var userInfo = this.userInfo;
		return userInfo && userInfo.user_role == 2;
	}

	isTeacher(): boolean {
		var userInfo = this.userInfo;
		return userInfo && userInfo.user_role == 3;
	}
	
	public t = (tc,sc,en)=>{
		let obj = {tc,sc,en};
		return obj[this.lang] || '';
	};
}
